module.exports = __webpack_public_path__ + "static/media/27-WaterHeatExchanger - Water cool - Water heat.e54367ee.png";